import { Action } from '@ngrx/store';
import { Offer, SearchParameters } from '../states/trip-finder.state';
import { type } from '../util';

export const ActionTypes = {
	LOADING: type('[Trip-Finder] loading'),
	PUT_SEARCH_PARAMETERS: type('[Trip-Finder] put search parameters'),
	PUT_OFFERS: type('[Trip-Finder] put offers'),
	PUT_SELECTED_OFFER: type('[Trip-Finder] put selected offer'),
	RESET: type('[Trip-Finder] reset')
};

export class Loading implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of Loading.
	 * @param {*} payload
	 * @memberof Loading
	 */
	constructor(public payload?) { }
}

export class PutSearchParameters implements Action {
	type = ActionTypes.PUT_SEARCH_PARAMETERS;

	/**
	 *Creates an instance of PutMensage.
	 * @param {SearchParameters} payload
	 * @memberof PutMensage
	 */
	constructor(public payload: SearchParameters) { }
}

export class PutOffers implements Action {
	type = ActionTypes.PUT_OFFERS;

	/**
	 *Creates an instance of PutOffer.
	 * @param {Array<Offer>} payload
	 * @memberof PutOffer
	 */
	constructor(public payload: Array<Offer>) { }
}

export class PutSelectedOffer implements Action {
	type = ActionTypes.PUT_SELECTED_OFFER;

	/**
	 *Creates an instance of PutSelectedOffer.
	 * @param {Offer} payload
	 * @memberof PutSelectedOffer
	 */
	constructor(public payload: Offer) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;

	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions = Loading | PutSearchParameters | PutOffers | PutSelectedOffer | ResetAction;
